<style lang="scss">
	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#handitemedit4 {
		.ant-row, .ant-calendar-picker{
			width: 100%;
		}

		.ant-form-item-label {
			width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 70% !important;

			.wart-t {
				width: 100%;
			}
		}
		.ant-calendar-picker-input{
			width: 100%;
		}
		.myright{
			.ant-form-item-label {
				width: 30% !important;
				padding-left: 10%;
			}
		}
		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 30% !important;
			}

			.ant-form-item-control-wrapper {
				width: 60% !important;

			}
		}

		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
</style>

<template>
	<div id='handitemedit4'>
		<div class="tabelMoreFzView main-mybody">
			<div class="tabelMoreFzViewIn">
				<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" :rules='rules'
					hideRequiredMark>
					<a-row>
						<a-col :span='12'>
							<a-form-model-item label="貸款比率" prop='loan_ratio'>
								<a-input v-model="form.loan_ratio" class='warp_width' :disabled='ipoAduitAdmin' suffix='%' @input='numfn("loan_ratio")'/>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Loan ratio" prop='loan_ratio'>
								<a-input v-model="form.loan_ratio" class='warp_width' :disabled='ipoAduitAdmin' suffix='%' @input='numfn("loan_ratio")'/>
								<!-- disabled -->
							</a-form-model-item>
						</a-col>
						
						<a-col :span='12'>
							<a-form-model-item label="日數" prop='loan_days'>
								<a-input v-model="form.loan_days" class='warp_width' :disabled='ipoAduitAdmin' @input='numfn("loan_days")'/>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Days" prop='loan_days'>
								<a-input v-model="form.loan_days" class='warp_width' :disabled='ipoAduitAdmin' @input='numfn("loan_days")'/>
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="息率" prop='gain'>
								<a-input v-model="form.gain" class='warp_width' :disabled='ipoAduitAdmin' suffix="%"  @input='numfn("gain")'/>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Interest rate" prop='gain'>
								<a-input v-model="form.gain" class='warp_width' :disabled='ipoAduitAdmin' suffix="%" @input='numfn("gain")'/>
							</a-form-model-item>
						</a-col>
					</a-row>
				</a-form-model>
			</div>
		</div>
		<div v-if='ipoAduitAdmin'   class='warp_daochu'>
				<div style="padding-left: .5rem;" :style='{width:!shKhadmin1Bol? "34rem":"34.5rem"}'>
					<a-textarea v-model='remark' placeholder=" " allow-clear style='width: 100%;' />
				</div>
				<div>
					<!-- <div style="padding: .35rem 0;" v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0">
						<button class='btn1' v-if='!shKhadmin1Bol' @click='shTgEvent(record,"2")'
							style="background-color: #ed4849;">取消開戶</button>
						<button class='btn1 btnx' @click='shTgEvent(record , 1)'>{{shKhadmin1Bol ? '已處理' :'審核通過'}}</button>
					</div> -->
					<div style="padding: .35rem 0;" v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0">
						<button class='btn1' v-if='!shKhadmin1Bol' @click='shTgEvent(record,"2")'
							style="background-color: #ed4849;">審核拒絕</button>
						<button class='btn1 btnx' @click='shTgEvent(record , 1)'>{{shKhadmin1Bol ? '已處理' :'審核通過'}}</button>
					</div>
					<div style="padding: .35rem 0;" v-else>
						<button class='btn1' @click='shTgEvent(record, 2)' style="background-color: #ed4849;">審核拒絕</button>
						<button class='btn1 btnx' @click='shTgEvent(record , 1)'>審核通過</button>
					</div>
				</div>
			
		</div>
		<div class='warp_daochu' v-else>
			<div style="padding: .35rem 0;margin-left: auto;">
				<button class='btn1 btnx' @click='savefn'>保存</button>
				<button class='btn1 ' style="background-color: #f48d28;" @click='handokfn' >提交</button>
			</div>
		</div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';

	export default {
		props: ['record', 'forms'],
		data() {
			return {
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				remark:'',
				shKhadmin1Bol: false,
				rules: {},
				england: 'cn',
				lang: {},
				admintypeArr: [{
									text: '處理中',
										entext:'Processing',
										value: '0'
									},
									{
										text: '認購中',
										entext:'Subscribing',
										value: '1'
									},
									{
										text: '待上市',
										entext:'Planned IPO',
										value: '2'
									},
									{
										text: '已上市',
										entext:'Listed IPO',
										value: '3'
									},
									{
									   text: '已除牌',
										entext:'Delisted',
										value: '4'
									},
									{
									    text: '已失效',
										entext:'Expired',
										value: '5'
									}	
									],
				admintypeArrs: [{
						text: '主板',
						entext: 'Mainboard',
						value: '0'
					},
					{
						text: '創業板',
						entext: 'GEM board',
						value: '1'
					},
				],
				moreFzOption: [],
				form: {
					"pricelist": [{
						"pricekey": "",
						"priceval": ""
					}, ],
					stockname_en: '', //股票名稱英文
					cn_planned_company_name_en: '', //公司名稱英文 
					cn_planned_industry_name_en: '', //行業英文 
					"stockcode": "", //輸入股票代碼
					"stockname": "", //輸入股票名稱
					"offer_price_l": '', //招股價起始值
					"offer_price_h": '', //招股價最大值
					"pergshu": '', //每手股數
					"application_open": "", //認購日期起始
					"application_close": "", //認購日期截止
					"listingdate": "", //上市日期
					"entryfee": '', //入場費
					"cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					"status_cn": "", //上市狀態   已上市 （股票名称 股票代码）
					"plates_cn": "", //上市板塊
					"delivery_date": "", //遞表日期
					"baojianr": "", //保薦機構
					"anpantime": "", //暗盤時間
					"multiple": '', //認購倍數
					info: '',
					linkaddress: '',
					pricefileid: '',
					loan_ratio: '', // 比率
					loan_days: '', // 日數
					gain: '', // 利息
					// "adminid": "", // 錄入人唯一標識
				},
			}
		},
		mounted() {
			this.form = JSON.parse(JSON.stringify(this.forms))
			this.lang = this.england == 'cn' ? this.$big5.sub : this.$eng.sub
		},
		methods: {
			handokfn(){
				this.$refs.ruleForm.validate(valid => {
					/*if (this.form.status_cn < 3) {
					if (!this.form.cn_planned_company_name_en || !this.form.cn_planned_industry_name_en) {
						this.$message.error('請填寫英文數據');
						return
					}
				}
				if (this.form.status_cn == 3||this.form.status_cn == 1){
					if (!this.form.stockname_en) {
						this.$message.error('請填寫英文股票名称');
						return
					}
				}  */ 
				
				if (valid) {
						this.form.token = this.$store.state.token
						this.$ajax({
							method: 'post',
							url: this.$api.newIpoSelling,
							headers: {
								token: this.$store.state.token,
							},
							data: this.form
						}).then(res => {
							if (res.data.qmiscode == 1000) {
								App.oTool.successT();
								this.$emit('child')
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					}
				})
			},
			savefn(){
				this.$ajax({
					method:'post',
					url:this.$api.newIpoSellingAudit,
					data:this.form
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.$message.success(res.data.qmismsg)
						this.$emit('child','save',res.data.id)
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			handen(){
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/<\/?.+?>/g,""); 
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/[\r\n]/g, ""); 
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/ +/g, ' ');
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.trim()
			},
			handcn() {
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/<\/?.+?>/g, "");
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/[\r\n]/g, "");
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/ +/g, ' ');
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.trim()
			},
			//禁止選擇
			deliveryDate(current) {
				return current && current > new Date(this.form.listingdate)
			},
			handkong() {
				this.form.info = this.form.info.replace(/<\/?.+?>/g, "");
				this.form.info = this.form.info.replace(/[\r\n]/g, "");
				this.form.info = this.form.info.replace(/ +/g, ' ');
				this.form.info = this.form.info.trim()
			},
			numfn(str){
				if(isNaN(this.form[str].split(',').join(''))){
					this.form[str] = ''
				}
			},
			getdata(record = this.record) {
				return
				let numarr = JSON.parse(JSON.stringify(this.fouten))
				let brr=[];
				for(let key in numarr){
					numarr[key].map((val,i)=>{
					if(val['pricekey']){
						val['pricekey'] = val['pricekey'].split(',').join('')
						if(val['priceval']){
							val['priceval'] = val['priceval'].split(',').join('')
								brr.push(val)   
						}
					}
				})
				}
				this.form.pricelist = brr;
				
				this.$refs.ruleForm.validate(valid => {
					if (this.form.status_cn < 3) {
					if (!this.form.cn_planned_company_name_en || !this.form.cn_planned_industry_name_en) {
						this.$message.error('請填寫英文數據');
						return
					}
				}
				if (this.form.status_cn == 3||this.form.status_cn == 1){
					if (!this.form.stockname_en) {
						this.$message.error('請填寫英文股票名称');
						return
					}
				}/*  */
			
				if (valid) {
						this.form.token = this.$store.state.token
						this.$ajax({
							method: 'post',
							url: this.$api.newIpoSelling,
							headers: {
								token: this.$store.state.token,
							},
							data: this.form
						}).then(res => {
							if (res.data.qmiscode == 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					}
				})
			},
			shUnTgEvent(record) {
				if (!this.remark) {
					App.oTool.warningT('請填寫備註信息');
					return
				}
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.KhAdminAduit, {
					admintype: _this.forms.admintype,
					token: json.token,
					id: record.pdfcode,
					khid: record.pdfcode,
					status: '1',
					remark: this.remark
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						App.oTool.successT('操作成功');
						this.$emit('child', true);
					} else {
						App.oTool.warningT(data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			shTgEvent(record, type) {
				if (!this.remark) {
					if (type == 1) {
						this.remark = '審核通過'
					} else if (type == 2 && !this.remark) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}
				
				this.$ajax({
					method: 'post',
					url: this.$api.ipoAdmin,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"iposelling_id": this.form.iposelling_id,
						token: this.$store.state.token,
						"handle": type,
						remark: this.remark
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child');
						this.shShowBol = false;
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},

			moreEvent(record = this.record) {
				let _this = this;
				if (record.schedule == 4 && record.status == 0 && !record.aduit) {
					App.oTool.warningT("開戶審核已完成");
					return;
				}
				if (record.status == 2) {
					App.oTool.warningT("開戶審核已取消");
					return;
				}
				if (record.websiteflag != 0 && record.finishflag == 1 && _this.form.admintype == 'khadmin1') {
				 App.oTool.warningT("沒有可用操作");
					return;
				}

				if (!record.moreShowBol) {
					let json = {
						token: _this.$store.state.token,
					}
					https.fetchPost(_this.$api.getOpeningInfo, {
						aduitflag: 1,
						id: record.pdfcode
					}, json).then((data) => {
						if (Object.is(data.qmiscode, 1000)) {
							this.moreFzOption = [{
									text: '證券帳號',
									value: data.khid
								},
								{
									text: '中文名稱',
									value: data.cn_name
								},
								{
									text: '英文名稱',
									value: data.en_name
								},
								{
									text: '電話號碼',
									value: data.phonenum
								},
								{
									text: '電郵地址',
									value: data.email
								},
					{
									text: '身份信息',
									value: data.id_number
								},
								{
									text: '銀行名稱',
									value: data.bank
								},
								{
									text: '銀行號碼',
									value: data.bank_number
								},
								{
									text: '地址信息',
									value: data.address
								},
							];
						} else {
							App.oTool.warningT(data.qmismsg);
						}
					}).catch(err => {
						console.log(err);
					});
				} else {
					//二级弹窗
					_this.visible_bold = false;
					//关闭一级弹窗
					record.moreShowBol = false;
				}
			},
		}
	}
</script>
<style scoped>
	#handitemedit4 .tabelMoreFzView .tabelMoreFzViewIn {
		background-color: #fff;
		padding: 0.7rem 0;
		border-radius: 4px;
		overflow: hidden;
	}

	#handitemedit4 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
		padding: 0.5rem 0;
		border-bottom: 1px #f3f3f3 solid;
		display: flex;
		align-items: flex-start;
	}

	#handitemedit4 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
		border: none;
	}

	#handitemedit4 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
		width: 24%;
		color: #000;
		font-size: 0.8rem;
	}

	#handitemedit4 .center {
		/* height: 1.7rem;
		    line-height: 1.7rem; */
	}

	#handitemedit4 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
		font-size: 0.8rem;
		width: calc(70% - 2rem);
		color: #000;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#handitemedit4 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
		width: 1.2rem;
		height: 1.2rem;
		margin: auto 0;
		margin-left: auto;
	}
</style>
